import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';

const baseStyles = {
    container: {
        position: 'absolute',
        ...StyleSheet.absoluteFill,
        flex: 1,
        alignSelf: 'stretch',
        width: '100%',
        height: '100%'
    },
    recordPage: {
        paddingHorizontal: '17%',
        paddingTop: '2%'
    }
};

if (Device.isTabletOrWeb) {
    baseStyles.recordPage = {
        position: 'absolute',
        bottom: Device.isWeb ? 118 : 83,
        left: 11,
        width: 460,
        height: 'auto',
        paddingVertical: 40,
        borderRadius: 3,
        borderWidth: 1,
        borderColor: 'rgba(164,164,164,0.3)'
    };
}

export default StyleSheet.create(baseStyles);
